import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { CognitiveFitness } from '../../model';
import parseSart from './parseSart';
import parseSpatialPlanning from './parseSpatialPlanning';
import parseVisualReaction from './parseVisualReaction';
import { buildDefaultCognitivePlaceholder } from './placeholders';

const parseCognitiveResults = (
    t: TFunction,
    items: AssessmentResultItemDataFragment[],
    incompleteItems: AssessmentResultItemDataFragment[] = []
): CognitiveFitness[] => {
    const incompleteModuleInstanceIds = new Set(incompleteItems.map(i => i.moduleInstance?.id));

    const completedItems = items.filter(
        i => !i.moduleInstance?.id || !incompleteModuleInstanceIds.has(i.moduleInstance.id)
    );

    const results: CognitiveFitness[] = [];

    // SART
    const completedSart = parseSart(t, completedItems);
    if (completedSart) {
        results.push(completedSart);
    } else {
        const incompleteSart = incompleteItems.find(i => i.moduleInstance?.moduleDefinitionIdentifier === 'sart');
        if (incompleteSart) {
            const p = buildDefaultCognitivePlaceholder(t, incompleteSart);
            if (p) {
                results.push(p);
            }
        }
    }

    // Visual Reaction
    const completedVisualReaction = parseVisualReaction(t, completedItems);
    if (completedVisualReaction) {
        results.push(completedVisualReaction);
    } else {
        const incompleteVisualReaction = incompleteItems.find(
            i => i.moduleInstance?.moduleDefinitionIdentifier === 'visual-rxn'
        );
        if (incompleteVisualReaction) {
            const p = buildDefaultCognitivePlaceholder(t, incompleteVisualReaction);
            if (p) {
                results.push(p);
            }
        }
    }

    // Spatial Planning
    const completedSpatialPlanning = parseSpatialPlanning(t, completedItems);
    if (completedSpatialPlanning) {
        results.push(completedSpatialPlanning);
    } else {
        const incompleteSpatialPlanning = incompleteItems.find(
            i => i.moduleInstance?.moduleDefinitionIdentifier === 'spatial-planning'
        );
        if (incompleteSpatialPlanning) {
            const p = buildDefaultCognitivePlaceholder(t, incompleteSpatialPlanning);
            if (p) {
                results.push(p);
            }
        }
    }

    return results;
};

export default parseCognitiveResults;
